import Vue from 'vue';
import Vuex from 'vuex';
import * as actions from './actions';
import * as getters from './getters';
import auth from './modules/auth';
import gallery from './modules/gallery';
import about from './modules/about';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const store = new Vuex.Store({
  actions,
  getters,
  modules: {
    auth,
    gallery,
    about,
  },
  strict: debug,
});
if (module.hot) {
  module.hot.accept(['./actions', './getters', './modules/auth', './modules/gallery', './modules/about'], () => {
    /* eslint-dsable */
    const newActions = require('./actions').default;
    const newGetters = require('./getters').default;
    const newAuth = require('./modules/auth').default;
    const newGallery = require('./modules/gallery').default;
    const newAbout = require('./modules/about').default;
    /* eslint-enable */
    store.hotUpdate({
      actions: newActions,
      getters: newGetters,
      modules: {
        auth: newAuth,
        gallery: newGallery,
        about: newAbout,
      },
    });
  });
} export default store;



// WEBPACK FOOTER //
// ./src/store/index.js